// extracted by mini-css-extract-plugin
module.exports = {"block":"List-module--block--8VJOU","content":"List-module--content--11SbC"};